module.exports = __webpack_public_path__ + "static/media/howItWorks1.892e37d6.png";